import SchemeBusinessNoteService from '../services/scheme-business-note-service';

export const schemeBusinessNote = {
  namespaced: true,
  state: {
    notes: null,
    note: null,
  },
  actions: {
    newNote({ commit, rootState }, schemeBusinessId) {
      const template = rootState.auth.appData.models.schemeNote;
      const empty = JSON.parse(JSON.stringify(template));
      empty.schemeBusinessId = schemeBusinessId;
      commit('setNote', empty);
    },
    listNotes({ commit }, schemeBusinessId) {
      commit('setIsBusy', true, { root: true });
      return SchemeBusinessNoteService.list(schemeBusinessId)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          commit('setNotes', result.model);
          return Promise.resolve(result);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    createNote({ commit }, data) {
      commit('setIsBusy', true, { root: true });
      return SchemeBusinessNoteService.create(data)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          const { message } = result;
          return Promise.resolve(message);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    getNote({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      commit('setNote', null);
      return SchemeBusinessNoteService.get(payload.schemeBusinessId, payload.noteId).then(
        (result) => {
          commit('setIsBusy', false, { root: true });
          commit('setNote', result.model);
          return Promise.resolve(result);
        },
        (error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        }
      );
    },
    updateNote({ commit }, data) {
      commit('setIsBusy', true, { root: true });
      return SchemeBusinessNoteService.update(data)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          const { message } = result;
          return Promise.resolve(message);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
    deleteNote({ commit }, payload) {
      commit('setIsBusy', true, { root: true });
      return SchemeBusinessNoteService.delete(payload)
        .then((result) => {
          commit('setIsBusy', false, { root: true });
          const { message } = result;
          return Promise.resolve(message);
        })
        .catch((error) => {
          commit('setIsBusy', false, { root: true });
          return Promise.reject(error);
        });
    },
  },
  mutations: {
    setNotes(state, newNotes) {
      state.notes = newNotes;
    },
    setNote(state, newNote) {
      state.note = newNote;
    },
  },
};
